<template>
  <div class="edit-video-box">
    <div>
      <!-- 操作栏 -->
      <el-row>
        <div class="action-bar">
          <el-button type="primary" size="small" @click="handleClose()">返回</el-button>
          <el-form ref="form" :model="roleInfo" label-width="100px" :rules="rules">
            <el-col :span="12">
              <el-form-item label="角色名" prop="role">
                <el-input
                  v-model="roleInfo.role"
                  size="small"
                  placeholder="请输入角色名"
                  :disabled="flag1"
                ></el-input>
                <!-- <el-button v-model="checkedAll" type="warning" size="small" @click="set">全选权限</el-button> -->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商区码" prop="role1">
                <el-input
                  :disabled="flag1"
                  v-model="roleInfo.discCode"
                  size="small"
                  placeholder="商区码"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="页面权限">
                <el-tree
                  :data="permessiList"
                  :props="defaultProps"
                  show-checkbox
                  default-expand-all
                  node-key="title"
                  ref="tree"
                  highlight-current
                ></el-tree>
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item label="功能权限">
                <el-tree
                  :data="itemList"
                  :props="defaultProps"
                  show-checkbox
                  default-expand-all
                  node-key="name"
                  ref="treeItem"
                  highlight-current
                ></el-tree>
              </el-form-item>
            </el-col>
          </el-form>
        </div>
      </el-row>
      <div class="dialog-footer">
        <el-button
          class="submit"
          type="success"
          size="small"
          :loading="flag"
          @click="submitForm()"
        >保存配置信息</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import API from "@/api";
// import local from "@/utils/localStroage";
// import _ from "lodash";
export default {
  props: {
    // 父组件传递的参数
    type: String
  },
  data() {
    return {
      flag1: false,
      roleInfo: {
        discCode: "系统",
        status: false,
        role: "",
        id: "",
        itemAuth: "",
        apiAuth: ""
      },
      flag: false,
      itemList: [
        {
          name: "home",
          title: "首页",
          children: [
            {
              name: "isWallet",
              title: "钱包",
              children: [
                {
                  name: "isBalance",
                  title: "余额"
                },
                {
                  name: "isWithdrawBtn",
                  title: "提现"
                },
                {
                  name: "isBillBtn",
                  title: "账单"
                }
              ]
            },
            {
              name: "isShowLinks",
              title: "链接"
            },
            {
              name: "isTodayData",
              title: "今日数据",
              children: [
                {
                  name: "isTodayNewUIDCountGroup",
                  title: "新增用户数",
                  children: [
                    {
                      name: "isTodayNewUIDCount",
                      title: "累计"
                    },
                    {
                      name: "isTodayNewDirectUIDCount",
                      title: "直推"
                    },
                    {
                      name: "isTodayNewFissionUIDCount",
                      title: "裂变"
                    }
                  ]
                },
                {
                  name: "isTodayVisitUIDCountGroup",
                  title: "日活跃",
                  children: [
                    {
                      name: "isTodayVisitUIDCount",
                      title: "累计"
                    },
                    {
                      name: "isTodayDirectVisitUIDCount",
                      title: "直推"
                    },
                    {
                      name: "isTodayFissionVisitUIDCount",
                      title: "裂变"
                    }
                  ]
                },
                {
                  name: "isTodayRechargeCompleteOrderCountGroup",
                  title: "充值单数",
                  children: [
                    {
                      name: "isTodayRechargeCompleteOrderCount",
                      title: "累计"
                    },
                    {
                      name: "isTodayDirectRechargePaidOrderCount",
                      title: "直推"
                    },
                    {
                      name: "isTodayFissionRechargePaidOrderCount",
                      title: "裂变"
                    }
                  ]
                },
                {
                  name: "isTodayRechargeCompleteOrderAmountGroup",
                  title: "充值金额",
                  children: [
                    {
                      name: "isTodayRechargeCompleteOrderAmount",
                      title: "累计"
                    },
                    {
                      name: "isTodayDirectRechargePaidAmount",
                      title: "直推"
                    },
                    {
                      name: "isTodayFissionRechargePaidAmount",
                      title: "裂变"
                    }
                  ]
                }
              ]
            },

            {
              name: "isTotalData",
              title: "累计数据",
              children: [
                {
                  name: "isTotalNewUIDCountGroup",
                  title: "新增用户数",
                  children: [
                    {
                      name: "isTotalNewUIDCount",
                      title: "累计"
                    },
                    {
                      name: "isTotalNewDirectUIDCount",
                      title: "直推"
                    },
                    {
                      name: "isTotalNewFissionUIDCount",
                      title: "裂变"
                    }
                  ]
                },
                {
                  name: "isTotalVisitUIDCountGroup",
                  title: "日活跃",
                  children: [
                    {
                      name: "isTotalVisitUIDCount",
                      title: "累计"
                    },
                    {
                      name: "isTotalDirectVisitUIDCount",
                      title: "直推"
                    },
                    {
                      name: "isTotalFissionVisitUIDCount",
                      title: "裂变"
                    }
                  ]
                },
                {
                  name: "isTotalRechargeCompleteOrderCountGroup",
                  title: "充值单数",
                  children: [
                    {
                      name: "isTotalRechargeCompleteOrderCount",
                      title: "累计"
                    },
                    {
                      name: "isTotalDirectRechargePaidOrderCount",
                      title: "直推"
                    },
                    {
                      name: "isTotalFissionRechargePaidOrderCount",
                      title: "裂变"
                    }
                  ]
                },
                {
                  name: "isTotalRechargeCompleteOrderAmountGroup",
                  title: "充值金额",
                  children: [
                    {
                      name: "isTotalRechargeCompleteOrderAmount",
                      title: "累计"
                    },
                    {
                      name: "isTotalDirectRechargePaidAmount",
                      title: "直推"
                    },
                    {
                      name: "isTotalFissionRechargePaidAmount",
                      title: "裂变"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          name: "agentList",
          title: "商区列表",
          children: [
            {
              name: "isAgentDataList",
              title: "列表数据",
              children: [
                {
                  name: "isParentDividendRatio",
                  title: "收益比列"
                },
                {
                  name: "isDividendRatio1",
                  title: "分红比列"
                }
              ]
            }
          ]
        },
        {
          name: "statistics",
          title: "每日统计",
          children: [
            {
              name: "isFeatures",
              title: "操作功能",
              children: [
                {
                  name: "isTime",
                  title: "检索日期"
                },
                {
                  name: "isSerialNuber",
                  title: "检索推广序列"
                },
                {
                  name: "isSystemType",
                  title: "检索系统类型"
                },
                {
                  name: "isSearch",
                  title: "搜索"
                }
              ]
            },
            {
              name: "isDataList",
              title: "列表数据",
              children: [
                {
                  name: "isSumDate",
                  title: "日期"
                },
                {
                  name: "isDistrictCode",
                  title: "商区码"
                },
                {
                  name: "isSysType",
                  title: "系统类型"
                },
                {
                  name: "isSeqe",
                  title: "推广序列"
                },
                {
                  name: "isLinkRemark",
                  title: "链接备注"
                },
                {
                  name: "isDividendRatio",
                  title: "分红比"
                },
                {
                  name: "isName",
                  title: "商区账号"
                },
                {
                  name: "isNewUIDCount",
                  title: "新增用户数"
                },
                {
                  name: "isNewDirectUIDCount",
                  title: "新增直推用户数"
                },
                {
                  name: "isNewFissionUIDCount",
                  title: "新增裂变用户数"
                },
                {
                  name: "isVisitUIDCount",
                  title: "日活跃"
                },
                {
                  name: "isDirectVisitUIDCount",
                  title: "直推日活跃"
                },
                {
                  name: "isFissionVisitUIDCount",
                  title: "裂变日活跃"
                },
                {
                  name: "isRechargeCompleteOrderCount",
                  title: "充值单数"
                },
                {
                  name: "isDirectRechargePaidOrderCount",
                  title: "直推充值单数"
                },
                {
                  name: "isFissionRechargePaidOrderCount",
                  title: "裂变充值单数"
                },
                {
                  name: "isRechargeCompleteOrderAmount",
                  title: "充值金额"
                },
                {
                  name: "isDirectRechargePaidAmount",
                  title: "直推充值金额"
                },
                {
                  name: "isFissionRechargePaidAmount",
                  title: "裂变充值金额"
                },
                {
                  name: "isNextDayRetainUIDRatio",
                  title: "次日留存用户数"
                },
                {
                  name: "isDay3RetainUIDRatio",
                  title: "3日留存用户数"
                },
                {
                  name: "isDay7RetainUIDRatio",
                  title: "7日留存用户数"
                },
                {
                  name: "isDay15RetainUIDRatio",
                  title: "15日留存用户数"
                },
                {
                  name: "isDay30RetainUIDRatio",
                  title: "30日留存用户数"
                },
                {
                  name: "isDirectNextDayRetainUIDRatio",
                  title: "直推次日留存用户数"
                },
                {
                  name: "isDirectDay3RetainUIDRatio",
                  title: "直推3日留存用户数"
                },
                {
                  name: "isDirectDay7RetainUIDRatio",
                  title: "直推7日留存用户数"
                },
                {
                  name: "isDirectDay15RetainUIDRatio",
                  title: "直推15日留存用户数"
                },
                {
                  name: "isDirectDay30RetainUIDRatio",
                  title: "直推30日留存用户数"
                },
                {
                  name: "isFissionNextDayRetainUIDRatio",
                  title: "分裂次日留存用户数"
                },
                {
                  name: "isFissionDay3RetainUIDRatio",
                  title: "分裂3日留存用户数"
                },
                {
                  name: "isFissionDay7RetainUIDRatio",
                  title: "分裂7日留存用户数"
                },
                {
                  name: "isFissionDay15RetainUIDRatio",
                  title: "分裂15日留存用户数"
                },
                {
                  name: "isFissionDay30RetainUIDRatio",
                  title: "分裂30日留存用户数"
                }
              ]
            }
          ]
        }
      ],
      permessiList: [
        {
          path: "/home",
          name: "home",
          title: "首页",
          icon: "el-icon-s-home",
          level: 0,
          meta: { title: "首页" }
        },
        {
          path: "/roleMan",
          name: "RoleMan",
          level: 0,
          icon: "el-icon-s-cooperation",
          title: "权限管理",
          meta: { title: "权限管理" }
        },
        {
          path: "/agent-list",
          name: "agent-list",
          icon: "el-icon-s-cooperation",
          level: 0,
          title: "商区列表",
          meta: { title: "商区列表" }
        },
        {
          path: "/daily-statistics",
          name: "daily-statistics",
          level: 0,
          icon: "el-icon-s-data",
          title: "每日统计",
          meta: { title: "每日统计" }
        },
        {
          path: "/ad-review-list",
          name: "ad-review-list",
          icon: "el-icon-s-data",
          level: 0,
          title: "申请广告",
          meta: { title: "申请广告" }
        },
        {
          path: "/recharge-list",
          name: "recharge-list",
          icon: "el-icon-s-data",
          level: 0,
          title: "充值流水",
          meta: { title: "充值流水" }
        },
        {
          path: "/registered-list",
          name: "registered-list",
          icon: "el-icon-s-data",
          level: 0,
          title: "注册流水",
          meta: { title: "注册流水" }
        }
      ],
      checkedAll: false, //checkbox的值
      defaultProps: {
        children: "children",
        label: "title"
      },
      rules: {
        role: [{ required: true, message: "请输入角色名称", trigger: "blur" }]
        // role1: [{ required: true, message: "请输入商区码", trigger: "blur" }]
      }
    };
  },
  computed: {
    discCode() {
      return this.$store.state.loginModule.userInfo.code;
    }
  },
  created() {
    // this.permessiList = _.cloneDeep(permessiList);
  },
  methods: {
    /****************************权限列表数据*****************************/
    // 表单验证提交
    submitForm() {
      this.flag = true;
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.type === "add") {
            this.addRole();
          } else {
            this.editRole();
          }
        } else {
          this.flag = false;
          return false;
        }
      });
    },
    // 全选权限
    set() {
      if (this.checkedAll) {
        //全选
        this.$refs.tree.setCheckedNodes(this.tree);
        this.$refs.treeItem.setCheckedNodes(this.treeItem);
      }
      // else{
      //     //取消选中
      //      this.treeAll.setCheckedNodes(this.treeAll);
      //      this.treeItemAll.setCheckedNodes(this.treeItemAll);
      // }
    },
    //功能权限
    treeItemAuth() {
      let treeItem = this.$refs.treeItem;
      return {
        checked: treeItem.getCheckedNodes(),
        halfChecked: treeItem.getHalfCheckedKeys()
      };
    },
    // 添加角色
    addRole() {
      let tree = this.$refs.tree;
      let params = {
        discCode: this.roleInfo.discCode,
        apiAuth: JSON.stringify(tree.getCheckedNodes()),
        itemAuth: JSON.stringify(this.treeItemAuth()),
        role: this.roleInfo.role
      };
      if (params.discCode === "系统") {
        params.discCode = "ZERO_VALUE";
      }
      params.discCode = params.discCode || "ZERO_VALUE";
      API.addRole(params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success"
            });
            this.$emit("handlerRoleList");
          } else if (res.code === 9200) {
            this.$message.error("新增角色号低于当前最新角色");
          } else {
            this.$message.error("添加失败");
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 编辑角色
    editRole() {
      let tree = this.$refs.tree;
      let params = {
        apiAuth: JSON.stringify(tree.getCheckedNodes()),
        itemAuth: JSON.stringify(this.treeItemAuth()),
        authID: this.roleInfo.id,
        role: this.roleInfo.role,
        discCode: this.roleInfo.discCode
      };
      if (params.discCode === "系统" || params.discCode === "") {
        params.discCode = "ZERO_VALUE";
      }
      API.updateRole(params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "修改角色权限成功",
              type: "success"
            });
            this.$emit("handlerRoleList");
            this.handleClose();
          }
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 关闭弹窗
    handleClose() {
      this.$refs.tree.setCheckedNodes([]);
      this.$refs.form.resetFields();
      // 回调父组件的关闭函数
      this.$emit("handleClose");
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, row) {
      if (type === "edit") {
        this.flag1 = true;
        row.discCode = row.discCode ? row.discCode : "系统";
        this.roleInfo = row;
        let auth = this.roleInfo.apiAuth
          ? JSON.parse(this.roleInfo.apiAuth)
          : [];
        let itemAuth = this.roleInfo.itemAuth
          ? JSON.parse(this.roleInfo.itemAuth)
          : [];
        this.$refs.tree.setCheckedNodes(auth);
        this.$refs.treeItem.setCheckedNodes(itemAuth.checked);
      } else {
        this.flag1 = false;
      }
      // 默认显示权限树已有的权限
      // this.flag1 = type === "edit";
    }
  }
};
</script>
<style scoped>
.el-tree-node.is-expanded > .el-tree-node__children {
  display: flex;
  flex-direction: column;
}
.dialog-footer {
  position: absolute;
  top: 60px;
  left: 100px;
}
/* .submit{
  position: fixed;
  top: 600px;
  left: 300px;
} */
</style>
